import { getStyles } from '@kubit/web-ui-components/utils/getStyles';
import styled from 'styled-components';
export const ToggleWrapperStyled = styled.div `
  display: flex;
`;
export const SelectorRowRadioStyled = styled.input `
  appearance: none;
  ${({ styles }) => getStyles(styles)}

  &:before {
    content: '';
    ${({ checkedStyles }) => getStyles(checkedStyles)}
  }
`;
export const SelectorRowOptionStyled = styled.div `
  ${({ styles }) => getStyles(styles)}
`;
export const SelectorRowOptionLeftContentStyled = styled.div `
  ${({ styles }) => getStyles(styles)}
`;
export const SelectorRowOptionCenterContentStyled = styled.div `
  ${({ styles }) => getStyles(styles)}
`;
export const SelectorRowOptionRightContentStyled = styled.div `
  ${({ styles }) => getStyles(styles)}
`;
//# sourceMappingURL=selectorRow.styled.js.map